import React from 'react'
import { 
    Tooltip,IconButton
    } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';

const EditButton = ({...props}) => {

    const { handleEdit, pid } = props;

    return (
        <Tooltip title="Edit" onClick={e => handleEdit(pid)}>
            <IconButton aria-label="edit" size="large">
                <EditIcon />
            </IconButton>
        </Tooltip>
    );
}

export default EditButton;